<template>
	<div class="card mb_0">
		<div class="d_flex align_items_center mb_20" @click="$emit('back')">
			<span class="LEFTARROW mr_8"></span>
			<h3 class="title">
				{{ $t('rtr_activity-exchange.detail.title1') }}
			</h3>
		</div>
		<div class="bg_black_box mb_40">
			<div>
				<span v-if="exchangeInfo.transfer_type === 'BID'">{{
					$t('rtr_activity-exchange.detail.th1')
				}}</span>
				<span v-else>{{ $t('rtr_activity-exchange.detail.th12') }}</span>
				<p>
					<span class="body_l">{{ exchangeInfo.source_asset_code }}</span>
					{{ exchangeInfo.source_asset_title }}
				</p>
			</div>
			<div>
				<span>{{ $t('rtr_activity-exchange.detail.th2') }}</span>
				<p>
					<span class="body_l">
						{{ exchangeInfo.target_asset_code }}
					</span>
					{{ exchangeInfo.target_asset_title }}
				</p>
			</div>
			<div>
				<span v-if="exchangeInfo.transfer_type === 'BID'">{{
					$t('rtr_activity-exchange.detail.th3')
				}}</span>
				<span v-else>{{ $t('rtr_activity-exchange.detail.th13') }}</span>
				<p>{{ exchangeInfo.source_amount }}</p>
			</div>
			<div>
				<span>{{ $t('rtr_activity-exchange.th4') }}</span>
				<p>{{ exchangeInfo.target_amount }}</p>
			</div>
			<div>
				<span v-if="exchangeInfo.transfer_type === 'BID'">{{
					$t('rtr_activity-exchange.detail.th5')
				}}</span>
				<span v-else>{{ $t('rtr_activity-exchange.detail.th14') }}</span>
				<p class="tar">{{ exchangeInfo.source_account_number }}</p>
			</div>
			<div>
				<span>{{ $t('rtr_activity-exchange.detail.th6') }}</span>
				<p class="tar">{{ exchangeInfo.target_account_number }}</p>
			</div>
			<div>
				<span>{{ $t('rtr_activity-exchange.th5') }}</span>
				<p>{{ exchangeInfo.basic_rate }}</p>
			</div>
			<div>
				<span>{{ $t('rtr_activity-exchange.th6') }}</span>
				<p>
					{{ exchangeInfo.spread_rate }}
				</p>
			</div>
			<div>
				<span>{{ $t('rtr_activity-exchange.th7') }}</span>
				<p>
					{{ exchangeInfo.exchange_rate }}
				</p>
			</div>
			<div>
				<span>{{ $t('rtr_activity-exchange.th1') }}</span>
				<p>
					<span v-if="exchangeInfo.transfer_type === 'BID'" class="body_l">
						{{ $t('rtr_activity-exchange.buy') }}
					</span>
					<span v-else class="body_l">{{
						$t('rtr_activity-exchange.sell')
					}}</span>
				</p>
			</div>
			<div>
				<span>{{ $t('rtr_activity-exchange.th2') }}</span>
				<p>
					{{ $dayjs(exchangeInfo?.regdate).format('YYYY.MM.DD HH:mm:ss') }}
				</p>
			</div>
		</div>
		<!-- <table class="table_type_a">
			<colgroup>
				<col style="width: 180px" />
			</colgroup>
			<tbody>
				<tr>
					<th>{{ $t('rtr_activity-exchange.detail.th1') }}</th>
					<td>{{ exchangeInfo.source_asset_title }}</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.detail.th2') }}</th>
					<td>{{ exchangeInfo.target_asset_title }}</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.detail.th3') }}</th>
					<td>{{ exchangeInfo.source_amount }}</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.th4') }}</th>
					<td>{{ exchangeInfo.target_amount }}</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.detail.th5') }}</th>
					<td>
						{{ exchangeInfo.source_account_number }}
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.detail.th6') }}</th>
					<td>{{ exchangeInfo.target_account_number }}</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.th5') }}</th>
					<td>{{ exchangeInfo.basic_rate }}</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.th6') }}</th>
					<td>
						{{ exchangeInfo.spread_rate }}
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.th7') }}</th>
					<td>
						{{ exchangeInfo.exchange_rate }}
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.detail.th10') }}</th>
					<td>
						<span
							v-if="exchangeInfo.transfer_type === 'BID'"
							class="label_buy"
							>{{ $t('rtr_activity-exchange.buy') }}</span
						>
						<span v-else class="label_sell">{{
							$t('rtr_activity-exchange.sell')
						}}</span>
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.detail.th11') }}</th>
					<td>
						{{ $dayjs(exchangeInfo?.regdate).format('YYYY.MM.DD HH:mm:ss') }}
					</td>
				</tr>
			</tbody>
		</table>
		<div class="button_area tac mt_50">
			<button @click="$emit('back')">{{ $t('button.back') }}</button>
		</div> -->
	</div>
</template>

<script>
export default {
	name: 'ExchangeDetail',
	props: {
		exchangeInfo: {
			type: Object,
		},
	},
	created() {
		window.scrollTo(0, 0);
	},
};
</script>

<style scoped></style>
